export { default } from "./select-option";
